import type { Hint } from './smarts';
import './smartHint.css';

/** One suggestion from what the words ask for: its reason, one action, and a way to say no. Nothing when there is none. */
export function SmartHint({ hint, onDismiss }: { hint: Hint | null; onDismiss: () => void }) {
  if (!hint) return null;
  return (
    <div className="artwork-ai-hint" role="status">
      <span>{hint.text}</span>
      <button type="button" className="artwork-ai-hint-act" onClick={() => { hint.apply(); onDismiss(); }}>{hint.action}</button>
      <button type="button" className="artwork-ai-hint-x" aria-label="Dismiss suggestion" onClick={onDismiss}>
        <svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6" /></svg>
      </button>
    </div>
  );
}
